import { render, staticRenderFns } from "./HrHireRegistWork.vue?vue&type=template&id=efa01480&scoped=true&"
import script from "./HrHireRegistWork.vue?vue&type=script&lang=js&"
export * from "./HrHireRegistWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa01480",
  null
  
)

export default component.exports